import { useMutation } from '@tanstack/react-query'
import { supabase } from '../../api'

class OldPassError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'OldPass';
  }
}

const updatePassword = async (password: string, oldPass?:string) => {
  const { data: userData, error: userError } = await supabase.auth.getUser()
  if (userError) {
    throw new Error(userError.message)
  }

  if (oldPass && userData?.user?.user_metadata?.isPassSet) {
    const { data: sessionData } = await supabase.auth.getSession()

    const { error } = await supabase.auth.signInWithPassword(
      userData?.user?.email ? {
        email: userData?.user?.email || '',
        password: oldPass || '',
      } : {
        phone: userData?.user?.phone || '',
        password: oldPass || '',
      },
    )

    if (error) {
      supabase.auth.setSession({
        access_token: sessionData?.session?.access_token || '',
        refresh_token: sessionData?.session?.refresh_token || '',
      })
      throw new OldPassError(error?.message)
    }
  }

  const { data: updateData, error: updateError } = await supabase
    .auth
    .updateUser({ password, data: { isPassSet: true } });

  if (updateError) {
    throw new Error(updateError.message)
  }

  return updateData
}

export default function useUpdatePassword(password: string, oldPass?: string) {
  return useMutation(() => updatePassword(password, oldPass), {
    onSuccess: async (data) => data,
  })
}
